/**
 * Get reusable steps and their associated production steps for PSEs merge.
 * This function ensures that if multiple reusable steps share the same baseReusableProductionStep,
 * all such reusable steps and their production steps are included in the result.
 */
export const getReusableStepsAndProductionStepsForPSEsMerge = ({
    selectedReusableStepsIds = [],
    reusableStepsForMerge,
    reusableStepsByBaseMap = new Map()
}) => {
    const filteredReusableProductionSteps = reusableStepsForMerge.filter(reusableStep =>
		selectedReusableStepsIds.includes(reusableStep.objectId)
	)

	// Collect all production step IDs from filtered reusable steps
	const productionStepsIds = filteredReusableProductionSteps.flatMap(reusableProductionStep =>
		reusableProductionStep.productionSteps.map(productionStep => productionStep.id || productionStep.objectId)
	)

	// Add other reusable steps that share the same baseReusableProductionStep
	// Since in the options we only select one of them, we need to add the others
	const newSelectedReusableStepsIdsSet = new Set()
	const newProductionStepsIdsSet = new Set(productionStepsIds)

	for (const id of selectedReusableStepsIds) {
		const currentReusableStep = filteredReusableProductionSteps.find(reusableStep => reusableStep.objectId === id)
		if (currentReusableStep) {
			const reusableStepsByBase = reusableStepsByBaseMap.get(currentReusableStep.optionKey) || []
			if (reusableStepsByBase.length > 1) {
				// Add all reusable steps sharing the same baseReusableProductionStep
				for (const reusableStepByBase of reusableStepsByBase) {
					newSelectedReusableStepsIdsSet.add(reusableStepByBase.reusableStepId)
					// Add all their production step IDs
					reusableStepByBase.productionStepIds.forEach(pid => newProductionStepsIdsSet.add(pid))
				}
			} else {
				newSelectedReusableStepsIdsSet.add(id)
			}
		}
	}

	return {
		selectedReusableStepsIds: Array.from(newSelectedReusableStepsIdsSet),
		productionStepsIds: Array.from(newProductionStepsIdsSet)
	}
}
